enum RateTypeEnums {
    // constant
    POSITIVE = 1,   // all 5 star
    POSITIVE_AVERAGE = 2,   // 4-5 stars
    NEGATIVE = 4,   // all 1 star
    NEGATIVE_AVERAGE = 3,   // all 1-2 stars
}

export { RateTypeEnums };
